import { render, staticRenderFns } from "./DailyBonus.vue?vue&type=template&id=589c30fc&scoped=true"
import script from "./DailyBonus.vue?vue&type=script&lang=js"
export * from "./DailyBonus.vue?vue&type=script&lang=js"
import style0 from "./DailyBonus.vue?vue&type=style&index=0&id=589c30fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589c30fc",
  null
  
)

export default component.exports